import { useState } from "react";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import SecurityHeaders from "../../context/SecurityHeaders";
import SnackbarToast from "../../components/toasts/SnackbarToast";
import { useDispatch } from "react-redux";

const UpdateEbookPage = ({item,reload,handleClose}) => {
    const dispatch = useDispatch()

    const [pageNo, setPageNo] = useState(item.page_no);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
   const [open, setOpen] = useState({
        open: false,
        message: '',
        type: ''

    });
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        dispatch({type:'LOADING'})

        if (!pageNo ) {            
            dispatch({ type: "ERROR", payload: "Please fill all fields and select an image." });
            setMessage("Please fill all fields and select an image.");
            return; 
        }
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file && file.size > maxSize) {
            dispatch({ type: "ERROR", payload: "Image size must be less than 5MB." });
            return;
        }
       
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
     
        if ( file && !allowedTypes.includes(file.type)) {
            dispatch({ type: "ERROR", payload: "Only JPEG, PNG, or JPG images are allowed." });
            return;
        }

        const formData = new FormData();
        formData.append('id', item.id);
        formData.append("book_id", item.book_id);
        formData.append("page_no", pageNo);
        formData.append("image", file);

        try {
            const response = await axios.post(ENDPOINT+"update-ebook-page.php",formData,SecurityHeaders);

            if (response.data.status === "success") {
                setOpen((prev)=>({...prev, open: true, message:'Updated Successfully', type: "success" }));
                dispatch({type:'DONE_LOADING'})
                setMessage(`✅ Upload Successful: ${response.data.image_url}`);
                reload();
            } else {

dispatch({type:'ERROR',payload:'Error occurred while updating'})     
           setMessage(`❌ Error: ${response.data.message}`);
            }
        } catch (error) {
dispatch({type:'ERROR',payload:error.message})
            setMessage("❌ Network error. Try again!");
        }
    };

    return (
      <>
        <SnackbarToast open={open} handleClose={() => setOpen((pre) => ({ ...pre, open: false }))} />

<div className="container mt-4">
    <h2>Upload eBook Page</h2>
    <form onSubmit={handleSubmit} className="p-3 border rounded">
        

        <div className="mb-3">
            <label className="form-label">Page Number</label>
            <input
                type="number"
                className="form-control"
                value={pageNo}
                onChange={(e) => setPageNo(e.target.value)}
                
            />
        </div>

        <div className="mb-3">
            <label className="form-label">Upload Image</label>
            <input type="file" className="form-control" onChange={handleFileChange} />
        </div>

        <button type="submit" className="btn btn-primary">Upload</button>
    </form>

    {message && <p className="mt-3">{message}</p>}
</div></>
    );
};

export default UpdateEbookPage;
